/** 模型上传：版本号校验（同一模型类别下版本号不能重复）。 */

/**
 * 上传版本号校验：同一模型类别下版本号不能重复。
 * - existing：各模型类别已有的版本（含已停用的；新类别为空数组）；
 * - 本次提交里两个上传项用了同一类别 + 同一版本，也算重复（无法区分）。
 * 返回 {上传项 id: 错误文案}；没有问题的项不出现。
 */
export function uploadVersionErrors(
  items: Array<{ id: string; name: string; version: string }>,
  existing: Record<string, string[] | undefined>,
): Record<string, string> {
  const out: Record<string, string> = {};
  const seen = new Map<string, string>();
  for (const it of items) {
    const name = it.name.trim();
    const version = it.version.trim();
    if (!name || !version) {
      continue;
    }
    if ((existing[name] ?? []).includes(version)) {
      out[it.id] = `模型类别 ${name} 已有版本 ${version}，请换一个版本号`;
      continue;
    }
    const key = `${name}\u0000${version}`;
    if (seen.has(key)) {
      out[it.id] = `与本次另一项重复：同一模型类别 ${name} 下版本号 ${version} 只能用一次`;
      continue;
    }
    seen.set(key, it.id);
  }
  return out;
}

